import { keyframes } from '@mui/material';

/**
 * Chat-specific animations for status indicators, messages, and interactions
 */

// Pulsing animation for thinking dots
export const pulse = keyframes`
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.4;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
`;

// Typewriter cursor blinking animation
export const typewriter = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scaleY(1);
  }
  50% {
    opacity: 0.3;
    transform: scaleY(0.7);
  }
`;

// Fade in from bottom animation for messages
export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Slide in from left animation (for assistant messages)
export const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

// Slide in from right animation (for user messages)
export const slideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

/**
 * Animation durations for consistent timing
 */
export const animationDurations = {
  /** Fast interactions like hover effects */
  fast: '0.15s',
  /** Standard animations like message appear */
  normal: '0.3s',
  /** Slower animations like status changes */
  slow: '0.5s',
  /** Status indicator loops */
  statusLoop: {
    pulse: '1.5s',
    typewriter: '0.8s',
  },
};

/**
 * Standard transition strings for consistent motion
 */
export const transitions = {
  /** Hover effects on message bubbles */
  messageHover: 'all 0.2s ease',
  /** Status indicator transitions */
  statusChange: 'opacity 0.3s ease-in-out',
  /** Message bubble appearance */
  bubbleAppear: `${fadeIn} 0.3s ease-in`,
};

/**
 * CSS animation strings ready to use in sx prop
 */
export const animations = {
  /** Pulsing dot animation (1.5s infinite loop) */
  pulseDot: `${pulse} 1.5s infinite ease-in-out`,
  /** Typewriter cursor animation (0.8s infinite loop) */
  typewriterCursor: `${typewriter} 0.8s infinite`,
  /** Fade in message */
  fadeInMessage: `${fadeIn} 0.3s ease-in`,
  /** Slide in from left */
  slideInFromLeft: `${slideInLeft} 0.3s ease-out`,
  /** Slide in from right */
  slideInFromRight: `${slideInRight} 0.3s ease-out`,
};
